import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { FileCopy, CloudUpload } from "@material-ui/icons";
import { toast } from "react-toastify";
import { getBackendUrl } from "../../config";
import api from "../../services/api";

const ImportSessionModal = ({ open, onClose, whatsapp }) => {
  const [jsonData, setJsonData] = useState("");
  const [loading, setLoading] = useState(false);

  const backendUrl = getBackendUrl();
  const endpoint = `${backendUrl}/whatsapp-import-session`;
  const token = whatsapp?.token || "";

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copiado!");
  };

  const handleImportJson = async () => {
    if (!jsonData.trim()) {
      toast.error("Cole o JSON da sessão");
      return;
    }

    if (!token) {
      toast.error("Configure um Token na conexão antes de importar");
      return;
    }

    setLoading(true);
    try {
      const parsed = JSON.parse(jsonData);
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(parsed)
      });

      const result = await response.json();

      if (result.success) {
        toast.success("Sessão importada com sucesso! Conectando...");
        onClose();
      } else {
        toast.error(result.error || "Erro ao importar sessão");
      }
    } catch (err) {
      toast.error(`Erro: ${err.message}`);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <CloudUpload style={{ color: "#673ab7" }} />
          <span>Importar Sessão</span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          Importar via Extensão Chrome (recomendado)
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Use a extensão do Chrome para extrair a sessão automaticamente do WhatsApp Web.
        </Typography>

        <Box mb={2}>
          <Typography variant="caption" color="textSecondary">
            Endpoint (POST)
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={endpoint}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => copyToClipboard(endpoint)}>
                    <FileCopy fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Box>

        <Box mb={2}>
          <Typography variant="caption" color="textSecondary">
            Token da Conexão (Authorization: Bearer)
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={token}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => copyToClipboard(token)}>
                    <FileCopy fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          {!token && (
            <Typography variant="caption" color="error">
              ⚠️ Configure um Token nas configurações desta conexão
            </Typography>
          )}
        </Box>

        <Box mt={3} pt={2} borderTop="1px solid #eee">
          <Typography variant="subtitle2" gutterBottom>
            Ou importe colando o JSON (opcional)
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            size="small"
            placeholder='Cole aqui o JSON da sessão extraída...'
            value={jsonData}
            onChange={(e) => setJsonData(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleImportJson}
          disabled={loading || !jsonData.trim()}
          style={{ backgroundColor: "#673ab7" }}
        >
          {loading ? "Importando..." : "Importar JSON"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportSessionModal;
